import { ActionReducer } from '@ngrx/store';
import { CreateSoapState } from './create-soap.model';
import { initialState, SEARCH_CREATE_SOAP_RECORDS, GET_CREATE_SOAP_RECORDS, RESET_CREATE_SOAP_GRID_DATA, RESET_CREATE_SOAP_RECORDS_TO_INITIAL_STATE } from './create-soap.constants';
import { CLEAR_ALL_STORES_STATE, CustomAction } from '../index-store.constants';

export function createSoapReducer(state: CreateSoapState = initialState, action: CustomAction) {
    switch (action.type) {
        case SEARCH_CREATE_SOAP_RECORDS:
            return {
                patientRecordsSearchFilterFields: action.payload,
                patientRecordsSearchGridData: state.patientRecordsSearchGridData
            };
        case GET_CREATE_SOAP_RECORDS:
            return {
                patientRecordsSearchFilterFields: state.patientRecordsSearchFilterFields,
                patientRecordsSearchGridData: {
                    rowsPerPageOptions: state.patientRecordsSearchGridData.rowsPerPageOptions,
                    cols: state.patientRecordsSearchGridData.cols,
                    pageLinks: state.patientRecordsSearchGridData.pageLinks,
                    rows: action.payload.rows,
                    configuration: action.payload.configuration,
                    filterData: action.payload.filterData,
                    totalRecords: action.payload.totalRecords
                }
            };
        case RESET_CREATE_SOAP_GRID_DATA:
            return {
                patientRecordsSearchFilterFields: state.patientRecordsSearchFilterFields,
                patientRecordsSearchGridData: initialState.patientRecordsSearchGridData
            };
        case RESET_CREATE_SOAP_RECORDS_TO_INITIAL_STATE:
        case CLEAR_ALL_STORES_STATE:
            return {
                patientRecordsSearchFilterFields: initialState.patientRecordsSearchFilterFields,
                patientRecordsSearchGridData: initialState.patientRecordsSearchGridData
            };
        default:
            return state;
    }
}
